import { AtaTypes } from './types';

interface getAtasProps {
  page: number;
}

export const getAtas = ({ page }: getAtasProps) => ({
  types: [AtaTypes.GET_ATAS_REQUEST, AtaTypes.GET_ATAS_SUCCESS, AtaTypes.GET_ATAS_FAILURE],
  promise: (client: any) => client.get(`/ata_de_registro_preco.json?page=${page}`),
});

export const SearchAtas = (params: object, page: number) => {
  return {
    types: [
      AtaTypes.SEARCH_ATAS_REQUEST,
      AtaTypes.SEARCH_ATAS_SUCCESS,
      AtaTypes.SEARCH_ATAS_FAILURE,
    ],
    promise: (client: any) =>
      client.get(`/price_register/search?page=${page}`, {
        params,
      }),
  };
};
